import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';
import { MatDialog } from '@angular/material/dialog';
import { DashboardTurnsTypesRequestZoomCardComponent } from '../dashboard-turns-types-request-zoom-card/dashboard-turns-types-request-zoom-card.component';

@Component({
  selector: 'app-dashboard-turns-types-request-card',
  templateUrl: './dashboard-turns-types-request-card.component.html',
  styleUrls: ['./dashboard-turns-types-request-card.component.scss']
})
export class DashboardTurnsTypesRequestCardComponent implements OnInit, AfterViewInit {

  @ViewChild('requestTypes', { static: false }) requestTypesRef: ElementRef;
  @Input() data;
  @Input() colors;
  @Input() title;
  ctx;
  myChart;

  constructor(private dialog: MatDialog) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.ctx = this.requestTypesRef.nativeElement.getContext('2d');
    this.renderChart(this.data);
  }

  public statZoom() {
    this.dialog.open(DashboardTurnsTypesRequestZoomCardComponent, { data: { data: this.data, title: this.title, colors: this.colors } } );
  }

  private renderChart(data) {
    if (this.myChart) {
      this.myChart.destroy();
    }
    const labels = [];
    const counts = [];

    data.forEach((d) => {
      labels.push(d.label);
      counts.push(d.count.reduce((accumulator, currentValue) => accumulator + currentValue));
    });

    const colors = this.colors.slice(0, counts.length);
    const hoverColors = colors.map(c => c = c + 'EE');
    const total = counts.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);

    this.myChart = new Chart(this.ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Dataset 1',
            data: counts,
            backgroundColor: colors,
            borderColor: colors,
            hoverBackgroundColor: hoverColors,
            hoverBorderColor: hoverColors,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
          display: false
        }
      },
      plugins: [{
        id: 'total',
        font: {
          size: 14
        },
        beforeDraw: (chart) => {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            ctx.fillStyle = '#aaaaaa';
            const text12 = 'TOTAL';
            ctx.font = '14px sans-serif';
            ctx.fillText(text12, width / 2 - (ctx.measureText(text12).width / 2), height / 2 - 15 );
            const text11 = total;
            ctx.font = '34px sans-serif';
            ctx.fillText(text11, width / 2 - (ctx.measureText(text11).width / 2), height / 2 + 25);
            ctx.save();
        }
      }]
    });
  }
}
